module.exports = __webpack_public_path__ + "static/media/icon_arrow_categories.d08829a4.svg";